import React, { useEffect, useRef, useState } from 'react';
import { ActionButton } from '../ActionButton';
import styles from './styles.module.scss';

interface MessageModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  description: string;
  detail?: string;
}

export default function MessageModal({
  show,
  onClose,
  title,
  description,
  detail,
}: MessageModalProps) {
  const [showStatus, setShowStatus] = useState(show);
  const rootRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = React.useCallback(
    (e: MouseEvent) => {
      if (!rootRef.current || !contentRef.current) return;

      if (
        rootRef.current.contains(e.target as Node) &&
        !contentRef.current.contains(e.target as Node)
      ) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
      document.body.style.overflow = 'unset';
    };
  }, [show, handleOutsideClick]);

  useEffect(() => {
    setShowStatus(show);
  }, [show]);

  const renderLines = (text?: string) => {
    if (!text) return null;

    return text.split('\n').map((str, index) => (
      <React.Fragment key={index}>
        {str}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <div className={showStatus ? styles.loaderWrapper : styles.displayNone} ref={rootRef}>
      <div className={styles.modalRoot} ref={contentRef}>
        <div className={styles.title}>{title}</div>
        <div className={styles.mainContainer}>
          <div className={styles.descContainer}>{renderLines(description)}</div>
          <div className={styles.detailContainer}>{renderLines(detail)}</div>
        </div>
        <div className={styles.btnContainer}>
          <ActionButton
            content='閉じる'
            type='darkFill'
            className={styles.closeBtn}
            action={onClose}
          />
        </div>
      </div>
    </div>
  );
}
